import { Text } from "@gravity-ui/uikit";
import { ReactNode } from "react";
import { T } from "src/i18n";

import css from "./FormField.module.scss";

interface FormFieldProps {
  labelKey: string;
  labelDefault: string;
  children: ReactNode;
}

export const FormField = ({
  labelKey,
  labelDefault,
  children,
}: FormFieldProps) => (
  <div className={css.field}>
    <Text variant="subheader-1" className={css.label}>
      <T keyName={labelKey} defaultValue={labelDefault} />
    </Text>
    {children}
  </div>
);
